module.exports = __webpack_public_path__ + "media/images/story_ogp_image/default-0d66a984d4513f4f7babd26142c0c0f5.png";